/* ==========================================
   NORDAUS TRACK ORDER
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const form = document.getElementById("ndTrackOrderForm");

  if (!form) return;

  const orderInput = document.getElementById("ndOrderNumber");
  const emailInput = document.getElementById("ndOrderEmail");
  const result = document.getElementById("ndTrackResult");
  const button = form.querySelector("button");

  form.addEventListener("submit", function (e) {

    e.preventDefault();

    result.innerHTML = "";

    const order = orderInput.value.trim();
    const email = emailInput.value.trim();

    if (!order) {
      result.innerHTML =
        '<p style="color:#c0392b;">Please enter your Order Number.</p>';
      orderInput.focus();
      return;
    }

    if (!email) {
      result.innerHTML =
        '<p style="color:#c0392b;">Please enter your Email Address.</p>';
      emailInput.focus();
      return;
    }

    button.disabled = true;
    button.textContent = "Checking...";

    // Placeholder for Shiprocket integration
    setTimeout(() => {

      result.innerHTML = `
        <div style="
          padding:18px;
          border:1px solid #e5e5e5;
          background:#fafafa;
          border-radius:6px;
        ">
          <strong>Version 1 Ready</strong><br><br>
          Shiprocket tracking will be connected here.
        </div>
      `;

      button.disabled = false;
      button.textContent = "Track Order";

    }, 1200);

  });

});